
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import LeadCard from "@/components/dashboard/LeadCard";
import EmptyLeadState from "@/components/dashboard/EmptyLeadState";
import { motion } from "framer-motion";
import { staggerContainer } from "@/utils/animations";
import { Lead, Form } from "@/types";

interface LeadsSectionProps {
  recentLeads: Lead[];
  isLoading: boolean;
  forms: Form[]; // Add forms prop
}

const LeadsSection = ({ recentLeads, isLoading, forms }: LeadsSectionProps) => {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-xl font-bold">Recent Leads 📈</h2>
        <Button 
          variant="outline" 
          size="sm" 
          className="font-medium text-sm"
          onClick={() => navigate("/leads")}
        >
          View All
        </Button>
      </div>

      {isLoading ? (
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="h-24 rounded-lg bg-muted/50 animate-pulse w-full"
            ></div>
          ))}
        </div>
      ) : recentLeads.length > 0 ? (
        <motion.div 
          {...staggerContainer}
          className="space-y-3"
        >
          {recentLeads.map((lead, index) => (
            <LeadCard key={lead.id} lead={lead} index={index} forms={forms} />
          ))}
        </motion.div>
      ) : (
        <EmptyLeadState />
      )}
    </div>
  );
};

export default LeadsSection;
